import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=60f33e11&"
import script from "./MobileHeader.vue?vue&type=script&lang=js&"
export * from "./MobileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f33e11')) {
      api.createRecord('60f33e11', component.options)
    } else {
      api.reload('60f33e11', component.options)
    }
    module.hot.accept("./MobileHeader.vue?vue&type=template&id=60f33e11&", function () {
      api.rerender('60f33e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/MobileHeader.vue"
export default component.exports